// extracted by mini-css-extract-plugin
export default {"globalLoader":"SxC_ZpCwiyhTJ3k7I4VC","backdrop":"diAfOzXAMuxIN435Iygm","spinContainer":"oxLSOjKXrkJMaptoH_nh"};